module.exports = __webpack_public_path__ + "img/title_bg.8d4b9dc3.png";